<script>
    import { createEventDispatcher } from "svelte";
    import EditableSection from "../EditableSection.svelte";
    import EditHolidayPeriods from "../openingHours/EditHolidayPeriods.svelte";
    import EditPeriods from "../openingHours/EditPeriods.svelte";
    import ViewSpecialDays from "../openingHours/ViewSpecialDays.svelte";
    import ViewHolidayPeriods from "../openingHours/ViewHolidayPeriods.svelte";
    import ViewPeriods from "../openingHours/ViewPeriods.svelte";
    import EditSpecialDays from "../openingHours/EditSpecialDays.svelte";

    const dispatch = createEventDispatcher();

    export let openingHours;
    openingHours = openingHours ?? {};
</script>

<EditableSection title="Öffnungszeiten" on:edit={() => {dispatch("edit")}} on:save={() => {dispatch("save")}}>
    <div slot="edit">
        <EditPeriods bind:periods={openingHours.regular}/>
        <br>
        <h3>Feiertage</h3>
        <EditHolidayPeriods bind:holidays={openingHours.holidays}/>
        <br>
        <h3>Abweichende Tage</h3>
        <EditSpecialDays bind:specialDays={openingHours.specialDays}></EditSpecialDays>
    </div>
    <div slot="view">
        <ViewPeriods bind:periods={openingHours.regular}/>
        <br>
        <h3>Feiertage</h3>
        <ViewHolidayPeriods bind:holidays={openingHours.holidays}/>
        {#if openingHours.specialDays}
            <br>
            <h3>Abweichende Tage</h3>
            <ViewSpecialDays bind:specialDays={openingHours.specialDays}></ViewSpecialDays>
        {/if}
    </div>
</EditableSection>

<style>

</style>